// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) { return "src/" + "main" + ".css"; };